import fetch from 'isomorphic-fetch'

function checkResponseStatus (response, { extraAllow = [] } = {}) {
  if (
    (response.status >= 200 && response.status < 300) ||
    (extraAllow && extraAllow.indexOf(response.status) !== -1)
  ) {
    return response
  }
  throw new Error(response.status + ': ' + response.statusText)
}

// NOTE: this is more of a `jsonFetch` function, as snips.ai does not have an api
// -i.e. this function name is misleading and should be refactored.
export function apiFetch (endpoint, opts) {
  return fetch(
    endpoint,
    Object.assign(
      {
        headers: {
          'Content-Type': 'application/json'
        }
      },
      opts
    )
  )
    .then(checkResponseStatus)
    .then(res => res.json())
}



// WEBPACK FOOTER //
// ./frontend/scripts/utils/api.js